import MuiBox from "@mui/material/Box";
const Box = MuiBox;
export default Box;
